export default function Item({ item, card_class = "", viewItem, qty }) {
  return (
    <div
      className={`card rounded ${card_class}`}
      onClick={(e) => {
        e.stopPropagation();
        viewItem(e, item);
      }}
    >
      <div className="card-img">
        <img src={`/images/${item.name}.webp`} alt="logo" />
      </div>
      <div className="card-content">
        <p name="item_name" className="card-title" value="" readOnly>
          {item.name}
        </p>

        <p name="item_desc" className="card-description" value=" ">
          {item.description}
        </p>
      </div>
      <div className="card-price">
        <p name="item_price" value={item.price}>
          {item.price}
        </p>

        {qty ? (''
          // <button
          //   className={`rounded add-button`}
          //   onClick={(e) => {
          //     e.preventDefault();
          //     e.stopPropagation();
          //     viewItem(e, item);
          //   }}
          // >
          //   <img src="/images/68.webp" alt="minus-icon" />
          // </button>
        ) : (
          "Sold out"
        )}
      </div>
      <div></div>
      <div></div>

      <div className="card-interact-btns"></div>
    </div>
  );
}
